export default __webpack_public_path__ + "static/media/Dialpad2.f789a5ca.svg";